import { Modal } from 'antd';
import { useT } from '../../../locales';

interface DeleteUserConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function DeleteUserConfirmModal({
  open,
  onConfirm,
  onCancel,
  loading,
}: DeleteUserConfirmModalProps) {
  const t = useT();

  return (
    <Modal
      title={t('pages.users.deactivateTitle')}
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      destroyOnHidden
      okText={t('pages.users.deactivate')}
      okButtonProps={{ danger: true }}
    >
      <p>{t('pages.users.deactivateConfirm')}</p>
    </Modal>
  );
}
